import type * as React from 'react';
import { get } from '@Domain/Api';
import documentTemplateVersionFetched, {
	type DocumentTemplateVersionFetchedAction,
	type DocumentTemplateVersionFetchedPayload,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionFetched';
import documentTemplateVersionFetchFailed, {
	type DocumentTemplateVersionFetchFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateVersionFetchFailed';
import type FetchDocumentTemplateVersion from '@Application/Documents/Templates/Queries/FetchDocumentTemplateVersion';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTemplateVersionFetchedAction | DocumentTemplateVersionFetchFailedAction;

export default (query: FetchDocumentTemplateVersion) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<DocumentTemplateVersionFetchedPayload>(
				`${parameters.api.host}/api/organizations/${query.organizationId}/document-template-versions/${query.versionId}`,
			);

			const action = documentTemplateVersionFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTemplateVersionFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
